<template>
	<!-- 主页面 -->
	<div>
		<van-tabbar v-model="active" @change="onChange">
			<van-tabbar-item icon="wap-home-o">首页
			</van-tabbar-item>
			<van-tabbar-item icon="user-o">我的</van-tabbar-item>
		</van-tabbar>
		<myheader :backFlag="false" :headTitle="this.headTitle"></myheader>
		<transition :name="names">
			<keep-alive :include="indexKeepAlive">
				<router-view class="router-view"></router-view>
			</keep-alive>
		</transition>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	import Vue from "vue";
	import {
		Tabbar,
		TabbarItem
	} from "vant";
	export default {
		name: "zhlhIndex",
		components: {
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
		},
		data() {
			return {
				active: window.sessionStorage.getItem('event') || 0,
				home: {
					normal: require("../../assets/images/icon-shouye-s.png"),
					active: require("../../assets/images/icon-shouye.png"),
				},
				headTitle: '电子签约',
			};
		},
		activated() {
			console.log('index-activated')
			if (window.sessionStorage.getItem('event')) {
				var num = window.sessionStorage.getItem('event')
				//console.log('num', num)
				this.active = +num
			}
			//console.log('active', this.active)
			if (this.$store.state.reLogin) {
				this.active = 0
				this.$store.commit("changeReLogin", '')
				//console.log('active-reLogin', this.active)
			}
			this.onChange(this.active)
		},
		deactivated() {
			//console.log('index-deactivated')
		},
		created() {
			//console.log('index-created')
		},
		updated() {
			//console.log('index-updated')
		},
		destroyed() {
			//console.log('index-destroyed')
		},
		//拦截设置keepalive是否缓存
		beforeRouteLeave(to, from, next) {
			//console.log("index-beforeRouteLeave", to, from);
			if (to.meta.index > from.meta.index) {
				if (from.meta.keepAlive) {
					this.$store.commit('addKeepAlive', 'Index');
				}
				//console.log(from.name);
			} else {
				if (from.meta.keepAlive) {
					this.$store.commit('removeKeepAlive', 'Index');
				}
			}
			//console.log("index-beforeRouteLeave-1", this.$store.state.includePage)
			next();
		},
		mounted() {
			//console.log('index-mounted')
			this.resetActive()
		},
		computed: {
			...mapGetters(["direction", "indexKeepAlive"]),
			// 路由跳转动画
			names() {
				return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
			},
		},
		methods: {
			//充值页面状态
			resetActive(){
				if (window.sessionStorage.getItem('event')) {
					var num = window.sessionStorage.getItem('event')
					this.active = +num
				}
				if (this.$store.state.reLogin) {
					this.active = 0
					this.$store.commit("changeReLogin", '')
				}
				this.onChange(this.active)
			},
			//获取个人信息
			getUserInfo() {
				this.$post("/my/api/getDetailForMobile")
					.then((res) => {
						if (res.success && res.data) {
							this.$store.dispatch("actionUserInfo", res.data);
						}
					});
			},
			// 切换时的回调。
			onChange(event) {
				switch (event) {
					case 0:
						this.headTitle = '电子签约'
						this.switchItem('/zhlh/home')
						break;
					case 1:
						this.headTitle = '我的'
						this.switchItem('/zhlh/user')
						break;
				}
				this.active = event
				window.sessionStorage.setItem('event', event)
			},
			//切换item页面
			switchItem(path) {
				console.log('switchItem', path)
				if (this.$router.currentRoute.path != path) {
					this.$router.replace(path)
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>